import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "slider-track" }
const _hoisted_2 = {
  key: 0,
  class: "slider-tooltip"
}
const _hoisted_3 = {
  key: 0,
  class: "slider-marks"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mark-label" }
const _hoisted_6 = {
  key: 0,
  class: "slider-input-container"
}
const _hoisted_7 = ["min", "max", "step", "disabled"]
const _hoisted_8 = { class: "slider-input-suffix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider-container", { disabled: _ctx.props.disabled, vertical: _ctx.props.vertical }])
  }, [
    _createElementVNode("div", {
      class: "slider-wrapper",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSliderClick && _ctx.handleSliderClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "slider-progress",
          style: _normalizeStyle({ width: `${((_ctx.normalizedValue - _ctx.props.min) / (_ctx.props.max - _ctx.props.min)) * 100}%` })
        }, null, 4)
      ]),
      _createElementVNode("div", {
        ref: "sliderThumb",
        class: "slider-thumb",
        style: _normalizeStyle({ left: `${((_ctx.normalizedValue - _ctx.props.min) / (_ctx.props.max - _ctx.props.min)) * 100}%` }),
        tabindex: "0",
        onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
        onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focusThumb && _ctx.focusThumb(...args)))
      }, [
        (_ctx.props.showTooltip)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.formatValue(_ctx.normalizedValue)), 1))
          : _createCommentVNode("", true)
      ], 36),
      (_ctx.props.showMarks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.marks, (mark, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["slider-mark", { active: _ctx.normalizedValue >= mark.value }]),
                style: _normalizeStyle({ left: `${((mark.value - _ctx.props.min) / (_ctx.props.max - _ctx.props.min)) * 100}%` }),
                onClick: ($event: any) => (_ctx.handleMarkClick(mark.value))
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(mark.label), 1)
              ], 14, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.props.showInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValue) = $event)),
            type: "number",
            min: _ctx.props.min,
            max: _ctx.props.max,
            step: _ctx.props.step,
            class: "slider-input",
            disabled: _ctx.props.disabled,
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
          }, null, 40, _hoisted_7), [
            [
              _vModelText,
              _ctx.inputValue,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.props.suffix), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}